<template>
  <div class="custom-main custom-theme">
    <a-spin :spinning="loading" tip="正在提交数据....">
      <a-form class="ant-advanced-search-form">
        <a-row class="searchrow width-style-auto">
          <a-form-item :colon="false" label="就诊机构">
            <a-select v-model="search.hospitalId">
              <a-select-option value="">--请选择--</a-select-option>
              <a-select-option v-for="item in init.organs" :key="item.oid" :value="item.oid">
                {{item.name}}
              </a-select-option>
            </a-select>
          </a-form-item>
          <a-form-item :colon="false" label="业务状态">
            <a-select v-model="search.status">
              <a-select-option value="">--请选择--</a-select-option>
              <a-select-option v-for="item in init.statuses" :key="item.name" :value="item.name">
                {{item.value}}
              </a-select-option>
            </a-select>
          </a-form-item>
          <a-form-item :colon="false" label="处方单号">
            <a-input v-model="search.code" placeholder="请输入处方单号检索">
              <img class="search-btn" slot="addonAfter" src="../../../assets/img/search.png" @click="searchAction"/>
            </a-input>
          </a-form-item>
        </a-row>
      </a-form>
      <a-row class="search"></a-row>
      <a-table size="middle" :columns="grid.columns" :loading="grid.loading"
               :rowSelection="{fixed:true, selectedRowKeys: grid.selections, onChange: onSelectChange}"
               rowKey="id" :dataSource="grid.data" :scroll="{ x: '100%' }" :pagination="grid.pagination"
               @change="gridChangeAction">
                <span slot="operate" slot-scope="text, record">
                  <a class="custom-primary-act" @click="()=>detailAction(record.id, '2')">详情</a>
                  <a-divider type="vertical" />
                  <a :class="((record.take == 'DELIVERY'|| record.take == 'SENT_CLINIC') && record.model == 'EXPRESS_DELIVERY' && (record.status=='D_DELIVERED' || record.status == 'Z_FINISHED')) ? 'custom-primary-act' : 'custom-normal-act'" :disabled="!((record.take == 'DELIVERY'|| record.take == 'SENT_CLINIC') && record.model == 'EXPRESS_DELIVERY' && (record.status=='D_DELIVERED' || record.status == 'Z_FINISHED'))" @click="()=>logisticsAction(record)">物流</a>
                  <a-divider type="vertical" />
                  <a :class="( record.status=='D_DELIVERED' && record.take == 'SENT_CLINIC') ? 'custom-primary-act' : 'custom-normal-act'" :disabled="!( record.status=='D_DELIVERED' && record.take == 'SENT_CLINIC')" @click="()=>showConformAction(record.id, '1', record.take)">确认收药</a>
                </span>
      </a-table>
    </a-spin>
    <a-modal :title="modal.title" :visible="modal.visible" width="70%" @cancel="closeModal" :okText="modal.type =='1' ? '确认收货' : '确认'" @ok="okAction()">
      <a-spin :spinning="modal.loading" :tip="modal.tip">
        <a-form :form="modal.form" layout="horizontal">
          <a-row>
            <a-col span="8" class="span-col height-45">
              <a-form-item label="患者姓名" :label-col="{sm: 24, md: 12, lg: 12, xl: 12, xxl: 12 }" :wrapper-col="{sm: 24, md: 12, lg: 12, xl: 12, xxl: 12 }">
                {{modal.record.name}}
              </a-form-item>
            </a-col>
            <a-col span="8" class="span-col height-45">
              <a-form-item label="性别" :label-col="{sm: 24, md: 12, lg: 12, xl: 12, xxl: 12 }" :wrapper-col="{sm: 24, md: 12, lg: 12, xl: 12, xxl: 12 }">
                {{modal.record.sexName}}
              </a-form-item>
            </a-col>
            <a-col span="8" class="span-col height-45">
              <a-form-item label="年龄" :label-col="{sm: 24, md: 12, lg: 12, xl: 12, xxl: 12 }" :wrapper-col="{sm: 24, md: 12, lg: 12, xl: 12, xxl: 12 }">
                {{modal.record.ageDesc}}
              </a-form-item>
            </a-col>

          </a-row>
          <a-row class="">
            <a-col span="8" class="span-col height-45">
              <a-form-item label="就诊医院" :label-col="{sm: 24, md: 12, lg: 12, xl: 12, xxl: 12 }" :wrapper-col="{sm: 24, md: 12, lg: 12, xl: 12, xxl: 12 }">
                {{modal.record.hospitalName}}
              </a-form-item>
            </a-col>
            <a-col span="8" class="span-col height-45">
              <a-form-item label="流转机构" :label-col="{sm: 24, md: 12, lg: 12, xl: 12, xxl: 12 }"  :wrapper-col="{sm: 24, md: 12, lg: 12, xl: 12, xxl: 12 }">
                {{modal.record.organName}}
              </a-form-item>
            </a-col>
            <a-col span="8" class="span-col height-45">
              <a-form-item label="申请时间" :label-col="{sm: 24, md: 12, lg: 12, xl: 12, xxl: 12 }"  :wrapper-col="{sm: 24, md: 12, lg: 12, xl: 12, xxl: 12 }">
                {{modal.record.applyTime}}
              </a-form-item>
            </a-col>
          </a-row>
          <a-row>
            <a-col span="8" class="span-col height-45">
              <a-form-item label="处方类型" :label-col="{sm: 24, md: 12, lg: 12, xl: 12, xxl: 12 }" :wrapper-col="{sm: 24, md: 12, lg: 12, xl: 12, xxl: 12 }">
                {{modal.record.typeName}}
              </a-form-item>
            </a-col>
            <a-col span="8" class="span-col height-45">
              <a-form-item label="处方单号" :label-col="{sm: 24, md: 12, lg: 12, xl: 12, xxl: 12 }" :wrapper-col="{sm: 24, md: 12, lg: 12, xl: 12, xxl: 12 }">
                {{modal.record.code}}
              </a-form-item>
            </a-col>
            <a-col span="8" class="span-col height-45">
              <a-form-item label="加工方式" :label-col="{sm: 24, md: 12, lg: 12, xl: 12, xxl: 12 }"  :wrapper-col="{sm: 24, md: 12, lg: 12, xl: 12, xxl: 12 }">
                {{modal.record.usageModelName}}
              </a-form-item>
            </a-col>
          </a-row>
          <a-row class="searchrow">
            <a-col span="8" class="span-col height-45">
              <a-form-item label="取药方式" :label-col="{sm: 24, md: 12, lg: 12, xl: 12, xxl: 12 }"  :wrapper-col="{sm: 24, md: 12, lg: 12, xl: 12, xxl: 12 }">
                {{modal.record.takeName}}
              </a-form-item>
            </a-col>
            <a-col span="16" class="span-col height-45">
              <a-form-item label="收货人" :label-col="{sm: 24, md: 12, lg: 6, xl: 6, xxl: 6 }"  :wrapper-col="{sm: 24, md: 12, lg: 18, xl: 18, xxl: 18 }">
                {{modal.record.consigneeName}}<span v-if="modal.record.consigneePhone!=null && modal.record.consigneePhone!=''">({{modal.record.consigneePhone}})</span>
                <span v-if="(modal.record.district!=null && modal.record.district!='')||(modal.record.address!=null && modal.record.address!='')">({{modal.record.district}} {{modal.record.address}})</span>
              </a-form-item>
            </a-col>
          </a-row>
          <a-row>
            <a-col span="8" class="span-col height-45">
              <a-form-item label="送货方式" :label-col="{sm: 24, md: 12, lg: 12, xl: 12, xxl: 12 }" :wrapper-col="{sm: 24, md: 12, lg: 12, xl: 12, xxl: 12 }">
                {{null != modal.record.delivery ? modal.record.delivery.modelName : ''}}
              </a-form-item>
            </a-col>
            <a-col v-if="modal.params.model=='EXPRESS_DELIVERY'" span="8" class="span-col height-45">
              <a-form-item label="快递公司" :label-col="{sm: 24, md: 12, lg: 12, xl: 12, xxl: 12 }" :wrapper-col="{sm: 24, md: 12, lg: 12, xl: 12, xxl: 12 }">
                {{null != modal.record.delivery ? modal.record.delivery.expressName : ''}}
              </a-form-item>
            </a-col>
            <a-col v-else span="8" class="span-col height-45">
              <a-form-item label="送货人" :label-col="{sm: 24, md: 12, lg: 12, xl: 12, xxl: 12 }" :wrapper-col="{sm: 24, md: 12, lg: 12, xl: 12, xxl: 12 }">
                {{null != modal.record.delivery ? modal.record.delivery.deliverer : ''}}
              </a-form-item>
            </a-col>
            <a-col v-if="modal.params.model=='EXPRESS_DELIVERY'" span="8" class="span-col height-45">
              <a-form-item label="快递单号" :label-col="{sm: 24, md: 12, lg: 12, xl: 12, xxl: 12 }" :wrapper-col="{sm: 24, md: 12, lg: 12, xl: 12, xxl: 12 }">
                {{null != modal.record.delivery ? modal.record.delivery.expressNo : ''}}
              </a-form-item>
            </a-col>
            <a-col v-else span="8" class="span-col height-45">
              <a-form-item label="联系电话" :label-col="{sm: 24, md: 12, lg: 12, xl: 12, xxl: 12 }"  :wrapper-col="{sm: 24, md: 12, lg: 12, xl: 12, xxl: 12 }">
                {{null != modal.record.delivery ? modal.record.delivery.delivererPhone : ''}}
              </a-form-item>
            </a-col>
            <a-col v-if="modal.type == '1' && modal.record.take == 'SENT_CLINIC' " span="8" class="span-col height-45">
              <a-form-item label="收获码" :label-col="{sm: 24, md: 12, lg: 12, xl: 12, xxl: 12 }"  :wrapper-col="{sm: 24, md: 12, lg: 12, xl: 12, xxl: 12 }">
                <a-input  v-decorator="['salt', {rules: [{ required: true, message: '收获码必须填写!' }] }]" placeholder="请输入收获码"/>
              </a-form-item>
            </a-col>
          </a-row>
        </a-form>
        <a-tabs default-active-key="1" size="small" style="min-height: 260px;">
          <a-tab-pane key="1" tab="流转处方">
            <a-table size="middle" :columns="modal.grid.columns" rowKey="code" :dataSource="modal.grid.datas" :scroll="{ x: '100%' }">
            </a-table>
          </a-tab-pane>
        </a-tabs>
      </a-spin>
    </a-modal>


    <a-modal title="物流信息" :visible="logisticsModal.visible" width="70%" :bodyStyle="{'height':'500px'}"  @cancel="logisticsModal.visible=false" @ok="logisticsModal.visible=false" >
      <a-spin :spinning="logisticsModal.loading" tip="正在加载数据...">
        <div style="height: 480px;overflow: auto">
          <a-row style="margin-bottom: 10px; font-size: 20px">
            <span style="font-weight: bolder">{{logisticsModal.logistics.unitName||''}}</span> <span style="margin-left: 8px">{{logisticsModal.logistics.expressNo}}</span>
          </a-row>
          <a-steps v-if="logisticsModal.logistics!=null && logisticsModal.logistics.items!=null" direction="vertical" :current="0" >
            <a-step v-for="item in logisticsModal.logistics.items"  :title="item.time" :description="item.context" />
          </a-steps>
        </div>
      </a-spin>
    </a-modal>

  </div>
</template>

<script>
  export default {
    name: "OrganRoam",
    data() {
      return {
        loading: false,
        init: {
          organs: [],
          statuses: statuses
        },
        search: {
          hospitalId: '',
          code: '',
          status: ''
        },
        grid: {
          loading: false,
          columns: columns,
          data: [],
          selections: [],
          pagination: this.$pagination
        },

        modal: {
          loading: false,
          visible: false,
          type:'1', //1-确认收药  2-详情
          title:'处方详情',
          tip : "正在加载数据...",
          record: {},
          models:[],
          btnProps:{
            props: { disabled: true }
          },
          params:{model:'EXPRESS_DELIVERY', deliverer:'', phone:'', expressNo:'', unit:''},
          grid: {
            columns: drugColumns,
            datas: []
          },
          form: this.$form.createForm(this),
        },

        logisticsModal:{
          loading: false,
          visible: false,
          record:{},
          logistics:{},
        }

      }
    },
    beforeCreate() {
      let data = [{
        text: "首页",
        path: ""
      }, {
        text: "云药房",
        path: ""
      }, {
        text: "处方流转(发起机构)",
        path: ""
      }];
      this.$store.commit('updateBreadcrumb', data);
    },
    mounted() {
      let self = this;
      this.loadHospitals();
      this.searchAction();
      this.getDeliveryModels(function (res) {
        self.modal.models = res||[]
      });
      this.getExpressUnits(function (res) {
        self.modal.units = res||[]
      });
      this.interval = setInterval(()=>{
        self.searchAction()
      }, 20000);
    },
    methods: {

      loadHospitals: function () {
        let self = this;
        this.$axios.get('/api/clinic/roam/organs', {}).then(function (res) {
          if (res.msg.flag == 0) {
            self.init.organs = res.biz;
          }
        })
      },

      buildParams: function () {
        return {
          'entity.hospitalId': this.search.hospitalId,
          'entity.code': this.search.code,
          'entity.status': this.search.status,
        };
      },
      /**
       * 搜索按钮点击动作
       */
      searchAction: function () {
        console.info('...查询');
        Object.assign(this.grid, {pagination: Object.assign(this.grid.pagination, {current: 1})});
        let params = Object.assign(this.buildParams(), {start: 0, length: this.grid.pagination.pageSize});
        this.loadGrid(params);
      },

      /**
       * 分页条操作
       */
      gridChangeAction: function (pagination, filters, sorter) {
        Object.assign(this.grid, {pagination: pagination});
        let params = Object.assign(this.buildParams(), {
          start: (pagination.current - 1) * pagination.pageSize,
          length: pagination.pageSize
        });
        this.loadGrid(params);
      },

      /**
       *  行选择事件
       */
      onSelectChange: function (selectedRowKeys) {
        this.grid.selections = selectedRowKeys;
      },

      /**
       * 查询流转处方
       */
      loadGrid: function (params) {
        const self = this;

        self.grid.loading = true;
        self.$axios.get('/api/clinic/organ/roam/recipes', {params: params}).then(function (res) {
          self.grid.loading = false;
          if (res.msg.flag == 0) {
            if (null == res.biz || res.biz.empty) {
              self.$message.info({content: res.msg.message, duration: 2});
              Object.assign(self.grid, {data: [], pagination: Object.assign(self.grid.pagination, {total: 0})});
            } else {
              Object.assign(self.grid, {
                data: res.biz.data,
                pagination: Object.assign(self.grid.pagination, {total: res.biz.count})
              });
            }
          } else {
            self.$message.error({content: res.msg.message, duration: 2});
          }
        }, function () {
          self.grid.loading = false;
        });
      },

      logisticsAction:function(record){
        let self = this;
        this.logisticsModal.logistics = {};
        this.logisticsModal.record = record;
        this.logisticsModal.visible = true;
        self.modal.loading = true;
        self.$axios.get('/api/clinic/roam/recipe/' + record.id+'/logistics', {}).then(function (res) {
          self.modal.loading = false;
          if (res.msg.flag == 0) {
            if (null == res.biz) {
              self.$message.info({content: res.msg.message, duration: 2});
            } else {
              Object.assign(self.logisticsModal.logistics, res.biz);
            }
          } else {
            self.$message.error({content: res.msg.message, duration: 2});
          }
        }, function () {
          self.modal.loading = false;
          self.$message.error({content: '加载数据失败', duration: 2});
        });
      },

      detailAction: function (id) {
        let self = this;
        self.modal.record = {};
        self.modal.grid.datas = [];
        self.modal.type = '2'; //1-确认收药  2-详情
        self.modal.title='处方详情';
        self.modal.tip="正在加载数据...";
        self.modal.visible = true;

        self.modal.loading = true;
        self.$axios.get('/api/clinic/roam/recipe/' + id, {}).then(function (res) {
          self.modal.loading = false;
          if (res.msg.flag == 0) {
            if (null == res.biz) {
              self.$message.info({content: res.msg.message, duration: 2});
            } else {
              Object.assign(self.modal.record, res.biz);
              Object.assign(self.modal.grid.datas, res.biz.drugs)
            }
          } else {
            self.$message.error({content: res.msg.message, duration: 2});
          }
        }, function () {
          self.modal.loading = false;
          self.$message.error({content: '加载数据失败', duration: 2});
        });
      },


      showConformAction: function (id) {
        let self = this;
        self.modal.record = {};
        self.modal.grid.datas = [];
        self.modal.type = '1'; //1-确认收药  2-详情
        self.modal.title='确认收药';
        self.modal.tip="正在加载数据...";
        self.modal.visible = true;
        self.modal.loading = true;
        self.$axios.get('/api/clinic/roam/recipe/' + id, {}).then(function (res) {
          self.modal.loading = false;
          if (res.msg.flag == 0) {
            if (null == res.biz) {
              self.$message.info({content: res.msg.message, duration: 2});
            } else {
              Object.assign(self.modal.record, res.biz);
              Object.assign(self.modal.grid.datas, res.biz.drugs)
            }
          } else {
            self.$message.error({content: res.msg.message, duration: 2});
          }
        }, function () {
          self.modal.loading = false;
          self.$message.error({content: '加载数据失败', duration: 2});
        });
      },

      okAction:function(){
        if(this.modal.type == '1'){
	        this.receiveSubmitAction();
        }else{
	        this.modal.visible = false

        }
      },

      receiveSubmitAction:function(){
        let self = this;



        self.modal.form.validateFields((errs, values)=>{
          if(!errs){

            let url = '';
            if(self.modal.record.take == 'SENT_CLINIC'){
              url = 'api/clinic/roam/recipe/'+self.modal.record.id+'/collect/'+values.salt;
            }else{
              url = '/api/clinic/roam/recipe/'+self.modal.record.id+'/receive'
            }
            self.modal.tip='正在确认收药信息...';
            self.modal.loading = true;
            self.$axios.post(url,{}).then(function(res){
              self.modal.loading = false;
              if(res.msg.flag == 0){
                self.modal.visible = false;
                self.$message.success({content:'收药确认成功', duration:2});
                self.gridChangeAction(self.grid.pagination)
              }else {
                self.$message.error({content:res.msg.message, duration:2})
              }
            })
          }
        })
      },

      modalChange:function(e){
        this.modal.params.model = e;
      },


      closeModal:function(){
        this.modal.visible = false
      },

    },

    beforeDestroy() {
      if(this.interval){
        clearInterval(this.interval);
      }
    }
  }

  let statuses = [
    {name: 'A_UNDERTRIAL', value: '待复审'},
    {name: 'B_WAIT_ACCEPT', value: '待受理'},
    {name: 'C_ACCEPTED', value: '已受理'},
    {name: 'D_DELIVERED', value: '已发货'},
    {name: 'Z_FINISHED', value: '已完成'},
  ];

  let columns = [
    {
      title: '处方单号',
      dataIndex: 'code',
      key: 'code',
      align: 'center',
      customRender: (text, record, index) => {
        return text == null || text == undefined ? '-' : text;
      },
      width: 180
    },
    {
      title: '姓名',
      dataIndex: 'name',
      key: 'name',
      align: 'center',
      customRender: (text, record, index) => {
        return text == null || text == undefined ? '-' : text;
      },
      width: 75
    },
    {
      title: '性别',
      dataIndex: 'sexName',
      key: 'sexName',
      align: 'center',
      customRender: (text, record, index) => {
        return text == null || text == undefined ? '-' : text;
      },
      width: 75
    },
    {
      title: '年龄',
      dataIndex: 'ageDesc',
      key: 'ageDesc',
      align: 'center',
      customRender: (text, record, index) => {
        return text == null || text == undefined || text.length == 0 ? '-' : text;
      },
      width: 75
    },
    {
      title: '就诊机构',
      dataIndex: 'hospitalName',
      key: 'hospitalName',
      align: 'center',
      customRender: (text, record, index) => {
        return text == null || text == undefined || text.length == 0 ? '-' : text;
      },
      width: 120
    },
    {
      title: '中药付数',
      dataIndex: 'doses',
      key: 'doses',
      align: 'center',
      customRender: (text, record, index) => {
        return text == null || text == undefined || text.length == 0 ? '-' : text;
      },
      width: 75
    },
    {
      title: '处方金额',
      dataIndex: 'roamAmount',
      key: 'roamAmount',
      align: 'center',
      customRender: (text, record, index) => {
        return text == null || text == undefined || text.length == 0 ? '-' : text.toFixed(2);
      },
      width: 75
    },
    {
      title: '申请时间',
      dataIndex: 'applyTime',
      key: 'applyTime',
      align: 'center',
      customRender: (text, record, index) => {
        return text == null || text == undefined || text.length == 0 ? '-' : text;
      },
      width: 140
    },
    {
      title: '取药方式',
      dataIndex: 'takeName',
      key: 'takeName',
      align: 'center',
      customRender: (text, record, index) => {
        return text == null || text == undefined || text.length == 0 ? '-' : text;
      },
      width: 100
    },
    {
      title: '状态',
      dataIndex: 'statusName',
      key: 'statusName',
      align: 'center',
      customRender: (text, record, index) => {
        return text == null || text == undefined || text.length == 0 ? '-' : text;
      },
      width: 120
    },
    {
      title: '配送方式',
      dataIndex: 'modelName',
      key: 'modelName',
      align: 'center',
      customRender: (text, record, index) => {
        return text == null || text == undefined || text.length == 0 ? '-' : text;
      },
      width: 90
    },
    {
      title: '配送方',
      dataIndex: 'deliverer',
      key: 'deliverer',
      align: 'center',
      customRender: (text, record, index) => {
        let info = '';
        if(record.model == 'HOME_DELIVERY'){
          info = record.deliverer||'-';
        }else if(record.model == 'EXPRESS_DELIVERY'){
          info = record.expressName||'-';
        }

        return info||'-';
      },
      width: 120
    },
    {
      title: '联系电话',
      dataIndex: 'delivererPhone',
      key: 'delivererPhone',
      align: 'center',
      customRender: (text, record, index) => {
        return text == null || text == undefined || text.length == 0 ? '-' : text;
      },
      width: 120
    },
    {
      title: '快递单号',
      dataIndex: 'expressNo',
      key: 'expressNo',
      align: 'center',
      customRender: (text, record, index) => {
        return text == null || text == undefined || text.length == 0 ? '-' : text;
      },
      width: 120
    },
    {
      title: '配送时间',
      dataIndex: 'deliveryTime',
      key: 'deliveryTime',
      align: 'center',
      customRender: (text, record, index) => {
        return text == null || text == undefined || text.length == 0 ? '-' : text;
      },
      width: 180
    },
    {
      title: '操作',
      key: 'operate',
      align: 'center',
      fixed: 'right',
      width: 180,
      scopedSlots: { customRender: 'operate'}
    }

  ]


  let drugColumns = [
    {
      title: '药品',
      dataIndex: 'drugName',
      key: 'drugName',
      align: 'center',
      customRender: (text, record, index) => {
        return text == null || text == undefined ? '-' : text;
      },
      width: 180
    },
    {
      title: '规格',
      dataIndex: 'spec',
      key: 'spec',
      align: 'center',
      customRender: (text, record, index) => {
        return text == null || text == undefined ? '-' : text;
      },
      width: 90
    },
    {
      title: '剂型',
      dataIndex: 'formName',
      key: 'formName',
      align: 'center',
      customRender: (text, record, index) => {
        return text == null || text == undefined ? '-' : text;
      },
      width: 90
    },
    {
      title: '生产厂家',
      dataIndex: 'manufacturer',
      key: 'manufacturer',
      align: 'center',
      customRender: (text, record, index) => {
        return text == null || text == undefined || text.length == 0 ? '-' : text;
      },
      width: 90
    },
    {
      title: '销售单位',
      dataIndex: 'salesUnit',
      key: 'salesUnit',
      align: 'center',
      customRender: (text, record, index) => {
        return text == null || text == undefined || text.length == 0 ? '-' : text;
      },
      width: 90
    },
    {
      title: '销售数量',
      dataIndex: 'salesQty',
      key: 'salesQty',
      align: 'center',
      customRender: (text, record, index) => {
        return text == null || text == undefined || text.length == 0 ? '-' : text;
      },
      width: 120
    }

  ]
</script>

<style scoped>

  .span-col{
    height: 45px;
  }

</style>
